import "/src/style/generalStyle.css";
import "/src/style/loginStyle.css";

export function LoginView(props) {
    function toggleVisiblePasswordACB() {
        props.togglePasswordVisibleACB();
    }
    function onWritingEmailACB(text) {
        props.writingChangedEmailACB(text.target.value);
    }
    function onWritingPasswordACB(text) {
        props.writingChangedPasswordACB(text.target.value);
    }
    function loginButtonPressedACB() {
        const email = document.querySelector(".loginInput").value;
        const password = document.querySelector(".secretInput").value;
        props.sendLoginACB(email, password);
    }
    function signupButtonPressedACB() {
        const email = document.querySelector(".loginInput").value;
        const password = document.querySelector(".secretInput").value;
        props.sendSignupACB(email, password);
    }
    return (
        <div>
            <div className="loginBox">
                <input
                    className="loginInput"
                    value={props.email || ""}
                    onChange={onWritingEmailACB}
                    placeholder="Email adress"
                />
                <input
                    className="loginInput secretInput"
                    type={props.showPassword ? "text" : "password"}
                    value={props.password || ""}
                    onChange={onWritingPasswordACB}
                    placeholder="Password"
                />
                <button className="passwordVisButton" onClick={toggleVisiblePasswordACB}>EYE</button>
                <button className="loginButton" onClick={loginButtonPressedACB}>Login</button>
                <button className="loginButton" onClick={signupButtonPressedACB}>Sign Up</button>
            </div>
        </div>
    );
}